// Sample Idea Farm products
export const sampleProducts = [
  // Event Tickets (Digital)
  {
    id: 'ticket-001',
    name: 'BARN SESSIONS - ACOUSTIC NIGHT',
    description: 'Intimate acoustic performance in our restored cow barn. Limited to 30 people. Includes welcome drink.',
    price: 25,
    category: 'tickets',
    type: 'digital',
    image: '/images/studio.png',
    inStock: true,
    stock: 30
  },
  {
    id: 'ticket-002',
    name: 'COURTYARD SUMMER FESTIVAL',
    description: 'Full day outdoor festival featuring local bands, food trucks, and craft workshops. Gates open 12pm.',
    price: 45,
    category: 'tickets',
    type: 'digital',
    image: '/images/aerialview.png',
    inStock: true,
    stock: 150
  },
  {
    id: 'ticket-003',
    name: 'RECORDING STUDIO TOUR',
    description: 'Behind-the-scenes tour of our 170m² recording studio. Learn about vintage equipment and recording techniques.',
    price: 15,
    category: 'tickets',
    type: 'digital',
    image: '/images/studio.png',
    inStock: true,
    stock: 20
  },

  // Merchandise
  {
    id: 'merch-001',
    name: 'IDEA FARM T-SHIRT - BLACK',
    description: 'Basic black tee with hand-printed Idea Farm logo. 100% organic cotton. Sizes S-XL.',
    price: 20,
    category: 'merchandise',
    type: 'physical',
    image: '/images/ideafarm_logo.png',
    inStock: true,
    stock: 50
  },
  {
    id: 'merch-002',
    name: 'BARN SESSIONS TOTE BAG',
    description: 'Heavy canvas tote bag featuring original barn illustration. Perfect for records, groceries, or lab tools.',
    price: 12,
    category: 'merchandise',
    type: 'physical',
    image: '/images/barnroof.png',
    inStock: true,
    stock: 25
  },
  {
    id: 'merch-003',
    name: 'IDEA FARM BEANIE',
    description: 'Warm wool beanie for those cold Swedish mornings. One size fits all.',
    price: 18,
    category: 'merchandise',
    type: 'physical',
    image: '/images/ideafarm_logo.png',
    inStock: true,
    stock: 30
  },

  // Artisan Crafts (from labs)
  {
    id: 'craft-001',
    name: 'HANDMADE WOODEN BOWL',
    description: 'Carved from local Swedish birch in our woodwork lab. Each piece is unique. Food-safe finish.',
    price: 35,
    category: 'crafts',
    type: 'physical',
    image: '/images/studios_tables.png',
    inStock: true,
    stock: 8
  },
  {
    id: 'craft-002',
    name: 'CERAMIC MUG - BARN SERIES',
    description: 'Hand-thrown ceramic mug inspired by our cow barn architecture. Microwave and dishwasher safe.',
    price: 22,
    category: 'crafts',
    type: 'physical',
    image: '/images/restaurant.png',
    inStock: true,
    stock: 12
  },
  {
    id: 'craft-003',
    name: 'METAL WALL ART - FARM TOOLS',
    description: 'Laser-cut steel wall art featuring vintage farm tool silhouettes. Powder-coated black finish.',
    price: 65,
    category: 'crafts',
    type: 'physical',
    image: '/images/digger.png',
    inStock: true,
    stock: 5
  },

  // Studio Recordings (Digital)
  {
    id: 'recording-001',
    name: 'BARN SESSIONS VOL. 1',
    description: 'Live recordings from our acoustic sessions. 8 tracks featuring local artists. High-quality WAV files.',
    price: 10,
    category: 'recordings',
    type: 'digital',
    image: '/images/pianobarn.png',
    inStock: true,
    stock: 999
  },
  {
    id: 'recording-002',
    name: 'AMBIENT FARM SOUNDS',
    description: 'Field recordings from around Idea Farm. Perfect for meditation, focus, or creative work. 1-hour loop.',
    price: 8,
    category: 'recordings',
    type: 'digital',
    image: '/images/gardens.png',
    inStock: true,
    stock: 999
  },
  {
    id: 'recording-003',
    name: 'STUDIO DEMO PACK',
    description: 'Sample pack recorded in our studio. Drums, bass, guitar stems. Royalty-free for your projects.',
    price: 15,
    category: 'recordings',
    type: 'digital',
    image: '/images/studio.png',
    inStock: true,
    stock: 999
  }
];

export const getProductsByCategory = (category) => {
  return sampleProducts.filter(product => product.category === category);
};

export const getProductById = (id) => {
  return sampleProducts.find(product => product.id === id);
};

export const getAllProducts = () => {
  return sampleProducts;
};
